
import MainNavigation from '@/components/navigation/MainNavigation.vue'
import FooterNavigation from '@/components/navigation/FooterNavigation.vue'
import RecentlyViewed from '@/components/panels/RecentlyViewed.vue'
import LocationDialog from '@/components/dialogs/LocationDialog.vue'

export default {
  components: {
    MainNavigation,
    FooterNavigation,
    RecentlyViewed,
    LocationDialog
  },
  data() {
    return {
      suggested: '',
      showLocationDialog: false
    }
  },
  mounted() {
    this.autoRouteMe()
  },
  methods: {
    autoRouteMe() {
      console.log('doing autoroute me')
      if(this.$k.isPre()) {
        console.log('botx-elephant')
        return
      }
      if(this.$k.isBot()) {
        return;
      }
      //console.log('THIS IS NOT A BOT')
      if(this.$store.state.langPref) {
        if(this.$route.name){
          if(!this.$route.name.startsWith('uni')) {
            if((this.$store.state.langPref === 'UK') && !this.$route.params.lang) {
              return
            }
            if(this.$store.state.langPref !== this.$route.params.lang) {
              this.goLang(this.$store.state.langPref)
            }
          }
        }
      }
      else {
        if(navigator.language) {
          let plang = this.$k.getSiteFromNavigator(navigator.language)
          if(plang !== this.$store.state.lang) {
            this.suggested = plang
            if(!this.$route.name.startsWith('uni')) {
              this.showLocationDialog = true
            }
          }
        }
      }
    },
    goLang(lg) {
      console.log('doing golang', lg, this.$ixr.path)
      this.$store.commit('setLang', lg)
      let path = this.$ixr.getPushPath(this.$ixr.path)
      if(this.$route.path !== path){
        this.$router.push(path)
      }
    }
  }
}